import React from 'react'
import { Route, Switch } from 'react-router-dom';
import AccessControl from '../../AccessControl';
import {
  MODULES_KEY,
  PERMISSION_OBJECT,
  ROUTES_MODULES_KEY,
} from '../../common/constants';
import './appBuild.less';
import AppBuilds from './appBuilds';
import ViewAppBuild from './components/ViewAppBuild';

function AppBuildsWrapper() {
  return (
    <Switch>
      <Route
        exact
        path={ROUTES_MODULES_KEY?.APP_BUILDS}
        render={(props) => (
          <AccessControl
            modulekey={MODULES_KEY?.APP_BUILDS}
            allowedPermissions={[PERMISSION_OBJECT?.read]}
            showNoAccess
          >
            <AppBuilds {...props} />
          </AccessControl>
        )}
      />
      <Route
        exact
        path={`${ROUTES_MODULES_KEY?.APP_BUILDS}/create`}
        render={(props) => (
          <AccessControl
            modulekey={MODULES_KEY?.APP_BUILDS}
            allowedPermissions={[PERMISSION_OBJECT?.create]}
            showNoAccess
          >
            <ViewAppBuild {...props} />
          </AccessControl>
        )}
      />
      <Route
        exact
        path={ROUTES_MODULES_KEY?.VIEW_APP_BUILD}
        render={(props) => (
          <AccessControl
            modulekey={MODULES_KEY?.APP_BUILDS}
            allowedPermissions={[PERMISSION_OBJECT?.read]}
            showNoAccess
          >
            <ViewAppBuild {...props} />
          </AccessControl>
        )}
      />
    </Switch>
  );
}

export default AppBuildsWrapper;
